import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["opened", "wide", "children"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { withToggle } from "../../../../enhancers";
import { BasePopupStateless } from "../BasePopup";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);

/**
 * Stateless popup layout with screen overlay
 * Appears by sliding down from top of the screen,
 * Content has predefined size and adaptive indents both outside and inside
 */
export function PopupStateless(_ref) {
  var opened = _ref.opened,
    wide = _ref.wide,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(BasePopupStateless, _extends({}, props, {
    isOpen: opened,
    isWide: wide,
    "data-t-id": "components-Popup"
  }), /*#__PURE__*/React.createElement("div", {
    className: cx('content'),
    "data-t-id": "components-Popup"
  }, children));
}
PopupStateless.propTypes = process.env.NODE_ENV !== "production" ? _objectSpread(_objectSpread({}, BasePopupStateless.propTypes), {}, {
  /** legacy prop names */
  opened: PropTypes.bool,
  wide: PropTypes.bool
}) : {};

/**
 * One-use popup, initially open, it can only be closed once and for good
 * For all other use cases, please refer to Stateless version
 */
export var PopupDisposable = withToggle(['opened'])(PopupStateless);
PopupDisposable.defaultProps = {
  opened: true
};